import { useAppSelector } from '@/store/hooks';
import { useLocaleSync } from '@/ui/@hooks/use-locale-sync';
import { cn } from '@/utils/tailwind';
import { FunctionComponent } from 'react';

import { SideBar } from './@components/side-bar';
import { TopBar } from './@components/top-bar/top-bar';

type DashLayoutProps = {
  greeting?: boolean;
  className?: string;
  children: React.ReactNode;
};

export const DashLayout: FunctionComponent<DashLayoutProps> = ({
  greeting,
  className,
  children,
}) => {
  const session = useAppSelector((state) => state.auth.session);
  const isAuthenticated = !!session;
  useLocaleSync();

  return (
    <div className={isAuthenticated ? 'md:pl-64' : ''}>
      {isAuthenticated && <SideBar />}
      {isAuthenticated && <TopBar greeting={greeting} />}
      <main
        className={cn(
          'min-h-[calc(100vh-(--spacing(16))-1px)] max-w-full py-12 mx-auto space-y-8 px-8 bg-muted dark:bg-background',
          !isAuthenticated && 'min-h-screen',
          className
        )}
      >
        {children}
      </main>
    </div>
  );
};
